import { cn } from 'utils/cn';

type SimpleTrackerProps = {
    currentValue?: string | number;
    storedValue?: string | number;
};

type IdTrackerProps = {
    currentParam?: number | string;
    displayValue?: string;
    storedParam?: number | string;
    textWrap?: 'wrap' | 'nowrap';
};

const TRACKER = 'text-grey-400 text-[12px] line-through';

export const InvoiceDetailsSimpleTracker = ({ currentValue, storedValue }: SimpleTrackerProps) =>
    currentValue != storedValue && storedValue ? <span className={TRACKER}>{storedValue}</span> : null;

export const InvoiceDetailsParameterizedTracker = ({
    textWrap,
    currentParam,
    displayValue,
    storedParam,
}: IdTrackerProps) =>
    currentParam !== storedParam && displayValue ? (
        <span className={cn(TRACKER, textWrap === 'nowrap' && 'text-nowrap', textWrap === 'wrap' && 'text-wrap')}>
            {displayValue}
        </span>
    ) : null;
